import type { DetectedFormat } from '../types';

const HTML_PATTERNS = [
  /<\/?[a-z][\s\S]*?>/i,
  /<!DOCTYPE html>/i,
  /<html[\s>]/i,
  /<head[\s>]/i,
  /<body[\s>]/i,
];

const MD_PATTERNS = [
  /^#{1,6}\s/m,
  /\*\*[^*]+\*\*/,
  /\*[^*]+\*/,
  /^[-*+]\s/m,
  /^\d+\.\s/m,
  /\[[^\]]+\]\([^)]+\)/,
  /^```/m,
  /^>\s/m,
  /^---$/m,
];

export function detectFormat(source: string): DetectedFormat {
  if (!source.trim()) {
    return 'md';
  }

  const hasHtml = HTML_PATTERNS.some((pattern) => pattern.test(source));
  const hasMd = MD_PATTERNS.some((pattern) => pattern.test(source));

  if (hasHtml && hasMd) {
    return 'hybrid';
  }
  if (hasHtml) {
    return 'html';
  }
  return 'md';
}
